/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonIdAddressesQueryResponse,
  GetApiV1PersonIdAddressesPathParams,
  GetApiV1PersonIdAddresses401,
  GetApiV1PersonIdAddresses404,
  GetApiV1PersonIdAddresses500,
} from "../../types/personRegisterController/GetApiV1PersonIdAddresses.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonIdAddresses } from "../../clients/personRegisterController/getApiV1PersonIdAddresses.ts";

export const getApiV1PersonIdAddressesQueryKey = (
  id: GetApiV1PersonIdAddressesPathParams["id"],
) => [{ url: "/api/v1/person/:id/addresses", params: { id: id } }] as const;

export type GetApiV1PersonIdAddressesQueryKey = ReturnType<
  typeof getApiV1PersonIdAddressesQueryKey
>;

export function getApiV1PersonIdAddressesQueryOptions(
  id: GetApiV1PersonIdAddressesPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonIdAddressesQueryKey(id);
  return queryOptions<
    GetApiV1PersonIdAddressesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdAddresses401
      | GetApiV1PersonIdAddresses404
      | GetApiV1PersonIdAddresses500
    >,
    GetApiV1PersonIdAddressesQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonIdAddresses(id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todos os endereços vinculados à pessoa. **(Requer Authorization para autenticação)**
 * @summary Listar endereços da pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/addresses}
 */
export function useGetApiV1PersonIdAddresses<
  TData = GetApiV1PersonIdAddressesQueryResponse,
  TQueryData = GetApiV1PersonIdAddressesQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonIdAddressesQueryKey,
>(
  id: GetApiV1PersonIdAddressesPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonIdAddressesQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonIdAddresses401
          | GetApiV1PersonIdAddresses404
          | GetApiV1PersonIdAddresses500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1PersonIdAddressesQueryKey(id);

  const query = useQuery(
    {
      ...getApiV1PersonIdAddressesQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonIdAddresses401
      | GetApiV1PersonIdAddresses404
      | GetApiV1PersonIdAddresses500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
